import { FC, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useMedia } from 'react-use';
// Components
import { PromoSlider } from './components/PromoSlider';
import { ScenesRow } from './components/ScenesRow';
import CustomRows from './components/CustomRows/CustomRows';
import { HomeSkeleton } from './components/HomeSkeleton';
import { useHomePageQuery } from './query';
import { RecommendedSlider } from './components/RecommendedSlider';
import {MovieModel, MoviesQueryModel} from './types';

const Home: FC = () => {
  const isMobile = useMedia('(max-width: 640px)');
  const isTablet = useMedia('(min-width: 641px) and (max-width: 1023px)');
  const isDesktop = useMedia('(min-width: 1024px) and (max-width: 1279px)');

  const { movies, banners, isLoading, isError, isSuccess } = useHomePageQuery();

  const queryNameMap: Record<string, string> = {
    top100_scenes: 'top-100/scenes',
    top100_movies: 'top-100/movies',
    new_movies: 'movies/all',
    latest_scenes: 'scenes/all',
  };

  return (
    <div id="home">
      <Helmet>
        <title>Beate Uhse Movie</title>
        <meta
          name="description"
          content="Auf Beate Uhse Movie bekommen Sie die besten deutschen Pornos und Filme der heißesten Darstellerinnen weltweit. Wählen Sie aus den besten Studios im Bereich Erotik."
        />
      </Helmet>
      {isLoading && <HomeSkeleton />}
      {isError && <p className="text-black text-center">Server error</p>}
      {isSuccess && (
        <div>
          <div className="home-top-banners block content-center justify-between items-center">
            <PromoSlider banners={banners?.top_banners || []}/>
          </div>
          <div className={`home-page`}>
            {Object.keys(movies).map((key, index) => {
              const property: keyof MoviesQueryModel = key as keyof MoviesQueryModel;
              const row = movies[property];

              if (row?.data) {
                const queryName = (() => {
                  const type = `${row.type}_${row.items}`;
                  if(type === 'amateurs_movies'){
                    if(!row.url) return '';
                    return (row?.url as string || '').split('.com')?.[1] || '';
                  }
                  return queryNameMap[type];
                })();
                return <RecommendedSlider big={index === 0} type={row.items} id={row.id} key={index} name={row.title} queryName={queryName} config={row.config} data={row.data} rawType={`${row.type}_${row.items}`} />;
              }

              return null;
            })}


              <CustomRows isMobile={isMobile} isTablet={isTablet} isDesktop={isDesktop} homePageStatus={isSuccess} />

          </div>
        </div>
      )}
    </div>
  );
};

export default Home;
